export default {
  refund: {
    id: 'asp_seller_action_bar_actions_list_step_refund_action',
    defaultMessage: 'Refund',
  },
  refundCustomerBlockedTooltip: {
    id: 'asp_seller_action_bar_actions_list_step_refund_customer_blocked_tooltip',
    defaultMessage: 'Refunds are blocked during fraud investigation.',
  },
}
